import { useLabel } from '@platform/hooks/useLabel';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { catalogLabel, moduleNav, navGroup } from '@platform/navigation';
import { useDesignSection } from '@platform/features/modules/design/useDesignSection';
import { CustomMenuHead } from './CustomMenuHead';
import { customMenuHeadOf } from './customMenuHeads';
import type { IMenuHeaderProps } from './IMenuHeaderProps';

/**
 * Заголовок меню модуля як у прототипі v4: група модуля (11px, верхній регістр), назва модуля (16px 700), «N записів» головної таблиці.
 * На сторінках модуля рядок над назвою — група верхнього меню, до якої належить модуль (модель навігації @platform/navigation: Справи —
 * «Управління», Верховна Рада — «Комітети»), а не категорія каталогу з визначення; поза модулем чи для модуля поза моделлю — переданий
 * `eyebrow`. Модулі з власним меню прототипу (завдання, база знань — customMenuHeads) мають заголовок «Модуль», лічильник
 * відкритих/оприлюднених і кнопку створення (CustomMenuHead) — крім розділів-списків «Проєктування», де прототип показує просту шапку
 * («Управління · Завдання · 79 записів»).
 */
export function MenuHeader({ eyebrow, title, meta }: IMenuHeaderProps) {
  const { ws, module } = useWorkspaceParams();
  const label = useLabel();
  const design = useDesignSection();
  const custom = design && design !== 'model' ? undefined : customMenuHeadOf(module);
  if (custom && ws) return <CustomMenuHead ws={ws} moduleKey={module} title={title} head={custom} />;
  const group = module ? navGroup(moduleNav(module).group) : undefined;
  const line = group ? label(catalogLabel(group)) || eyebrow : eyebrow;
  return (
    <div className="mnav__head">
      {line && <span className="mnav__eyebrow">{line}</span>}
      <span className="mnav__title">{title}</span>
      <span className="mnav__meta">{meta || ' '}</span>
    </div>
  );
}
